import { render, staticRenderFns } from "./Analise.vue?vue&type=template&id=6f5cb4f4&scoped=true"
import script from "./Analise.vue?vue&type=script&lang=js"
export * from "./Analise.vue?vue&type=script&lang=js"
import style0 from "./Analise.vue?vue&type=style&index=0&id=6f5cb4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5cb4f4",
  null
  
)

export default component.exports